module.exports = __webpack_public_path__ + "img/991.1b4d1d9d.jpg";